import {FC, lazy, Suspense} from 'react'
import {Navigate, Route, Routes, useLocation} from 'react-router-dom'
import {MasterLayout} from '../MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {DisableSidebar} from '../../shared/lib/core'
import {APP_URL, PermissionOutlet, WithChildren} from 'shared'

const PrivateRoutes = () => {

  const HomePage = lazy(() => import('pages/home'))
  const ProfilePage = lazy(() => import('pages/profile'))

  const OrdersPage = lazy(() => import('pages/orders-list'))
  const OrderViewPage = lazy(() => import('pages/order-view'))
  const OrderQualifyPage = lazy(() => import('pages/order-qualify'))

  const PaymentsListPage = lazy(() => import('pages/payments-list'))

  const CustomersListPage = lazy(() => import('pages/customers-list'))
  const CustomerViewPage = lazy(() => import('pages/customer-view'))

  const StatsPage = lazy(() => import('pages/org-stats'))

  const MailingListPage = lazy(() => import('pages/mailing-list'))
  const MailingComposePage = lazy(() => import('pages/mailing-compose'))

  const HartiyaListPage = lazy(() => import('pages/hartiya-list'))

  const AdminUsersListPage = lazy(() => import('pages/admin/users-list'))
  const AdminOrgsListPage = lazy(() => import('pages/admin/orgs-list'))
  const AdminOrgEditPage = lazy(() => import('pages/admin/org-edit'))

  const MyOrganizationPage = lazy(() => import('pages/my-org'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        
        {/* Redirect to Dashboard after success login/registartion */}
        {/* <Route path='auth/*' element={<Navigate to='/dashboard' />} /> */}
        
        {/* Pages */}
        <Route index element={<SuspensedView><HomePage/></SuspensedView>} />
        <Route path='home' element={<SuspensedView><HomePage/></SuspensedView>} />

        {/* Profile */}
        <Route path='profile/*' element={<SuspensedView><ProfilePage/></SuspensedView>}/>

        <Route path='orders' element={<PermissionOutlet role='Orders'/>}>
          <Route index element={<SuspensedView><OrdersPage/></SuspensedView>}/>
          <Route path='view/:typeId/:orderDate'>
            <Route index element={<SuspensedView><OrderViewPage/></SuspensedView>}/>
            <Route path=':completeDate' element={<SuspensedView><OrderViewPage/></SuspensedView>}/>
          </Route>
          <Route path='qualify/:typeId/:orderDate/:onQualificationDate' element={<SuspensedView><OrderQualifyPage/></SuspensedView>}/>
        </Route>

        <Route path='payments' element={<PermissionOutlet role='Payments'/>}>
          <Route index element={<SuspensedView><PaymentsListPage/></SuspensedView>} />
        </Route>

        <Route path='org'>
          <Route path='customers' element={<PermissionOutlet role='Stats'/>}>
            <Route path=':customerId' element={<SuspensedView><CustomerViewPage/></SuspensedView>} />
            <Route index element={<SuspensedView><CustomersListPage/></SuspensedView>} />
          </Route>
          <Route path='stats' element={<PermissionOutlet role='Stats'/>}>
            <Route index element={<SuspensedView><StatsPage/></SuspensedView>} />
          </Route>
          <Route path='mailing/*' element={<PermissionOutlet role='Stats'/>}>
            <Route path='compose'>
              <Route path=':id' element={<SuspensedView><MailingComposePage/></SuspensedView>}/>
              <Route index element={<SuspensedView><MailingComposePage/></SuspensedView>}/>
            </Route>
            <Route path='*' element={<SuspensedView><MailingListPage/></SuspensedView>} />
          </Route>
          <Route path='settings' element={<PermissionOutlet role='Moderator'/>}>
            <Route index element={<SuspensedView><MyOrganizationPage/></SuspensedView>}/>
          </Route>
          <Route path='hartiya' element={<PermissionOutlet role='Hartiya'/>}>
            <Route index element={<SuspensedView><HartiyaListPage/></SuspensedView>}/>
          </Route>
        </Route>
        
        <Route path='admin' element={<PermissionOutlet role='Admin'/>}>
          <Route path='users' element={<SuspensedView><AdminUsersListPage/></SuspensedView>}/>
          <Route path='orgs' element={<SuspensedView><AdminOrgsListPage/></SuspensedView>}/>
          <Route path='orgs/:id' element={<SuspensedView><AdminOrgEditPage/></SuspensedView>}/>
        </Route>

        {/* Page Not Found */}
        <Route path='*' element={<Error/>} />
      </Route>
    </Routes>
  )
}

const Error = () => {

  const location = useLocation()

  console.log('error')

  return <Navigate to={APP_URL.ERROR_404} replace/>;
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return (
    <Suspense fallback={<TopBarProgress />}>
      <DisableSidebar>{children}</DisableSidebar>
    </Suspense>
  )
}

export {PrivateRoutes}
